<template>
  <v-list-group
    append-icon="mdi-menu-down"
    :group="group"
    :prepend-icon="item.icon"
    :sub-group="subGroup"
    :color="
      barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'
        ? 'white'
        : 'grey darken-1'
    "
    :v-model="expanded"
    @change="expandedChanged"
  >
    <template v-slot:activator>
      <v-list-item-icon
        v-if="text"
        class="v-list-item__icon--text"
        v-text="''"
      />

      <v-list-item-content>
        <v-list-item-title v-text="item.title" />
      </v-list-item-content>
    </template>

    <template v-for="(child, i) in children">
      <base-item-sub-group
        v-if="child.children"
        :key="`sub-group-${i}`"
        :item="child"
        append-icon="mdi-menu-down"
      />

      <base-item
        v-else
        :key="`item-${i}`"
        :item="child"
        text
        @on-item-click="onChildItemClick"
      />
    </template>
  </v-list-group>
</template>

<script>
// Utilities
import kebabCase from "lodash/kebabCase";

export default {
  name: "ItemGroup",

  inheritAttrs: false,

  props: {
    item: {
      type: Object,
      default: () => ({
        avatar: undefined,
        group: undefined,
        title: undefined,
        children: [],
      }),
    },
    subGroup: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    expanded: false,
  }),

  computed: {
    barColor() {
      return this.$store.getters["theme/barColor"];
    },
    children() {
      return this.item.children.map((item) => ({
        ...item,
        to: !item.to ? undefined : `/${item.to}`,
      }));
    },
    // computedText() {
    //   if (!this.item || !this.item.title) return "";

    //   let text = "";

    //   this.item.title.split(" ").forEach(val => {
    //     text += val.substring(0, 1);
    //   });

    //   return text;
    // },
    group() {
      return this.genGroup(this.item.children);
    },
  },
  methods: {
    expandedChanged() {
      this.item.expanded = !(this.item.expanded || false);
      this.$emit("on-expanded");
    },
    genGroup(children) {
      return children
        .filter((item) => item.to)
        .map((item) => {
          const parent = item.group || this.item.group;
          let group = `${parent}/${kebabCase(item.to)}`;

          if (item.children) {
            group = `${group}|${this.genGroup(item.children)}`;
          }

          return group;
        })
        .join("|");
    },
    onChildItemClick(itemID) {
      this.$emit("on-child-item-click", itemID);
    },
  },
};
</script>

<style>
.v-list-group__activator p {
  margin-bottom: 0;
}
</style>
